// Light helpers for the app shell: kept apart from ./misc, which pulls the api and store barrels.
import { getAccessToken, isLoggedIn } from 'axios-jwt';
import { TFunction } from 'i18next';
import { decodeToken } from 'react-jwt';
import { DecodedToken, Role, User } from 'types';

type ExtractUserFromTokenFuncType = (accessToken?: string) => User;
export const extractUserFromToken: ExtractUserFromTokenFuncType = accessToken => {
  const decodedToken: DecodedToken = decodeToken(accessToken || getAccessToken() || '') as DecodedToken;

  return {
    user_id: decodedToken.user_id,
    employer_name: decodedToken.employer_name,
    entity_id: decodedToken.entity_id,
    name: decodedToken.name,
    email: decodedToken.email,
    position: decodedToken.position,
    role: decodedToken.role,
    read_only: decodedToken.read_only,
    otp_enabled: decodedToken.otp_enabled,
    scan_frequency_in_seconds: decodedToken.scan_frequency_in_seconds,
    theme: decodedToken.theme,
    logo_primary_dark: decodedToken.logo_primary_dark,
    logo_primary_light: decodedToken.logo_primary_light,
    logo_secondary_dark: decodedToken.logo_secondary_dark,
    logo_secondary_light: decodedToken.logo_secondary_light,
    color_scheme_light: decodedToken.color_scheme_light,
    color_scheme_dark: decodedToken.color_scheme_dark,
    client_approved: decodedToken.client_approved
  };
};

type HasRoleFuncType = (role: Role, roleNumber?: number) => boolean;
export const hasRole: HasRoleFuncType = (role, roleNumber) => roleNumber !== undefined && role === roleNumber;

type GetRoleByNumberFuncType = (role: number, t?: TFunction) => 'user' | 'admin' | 'firmadmin' | 'superadmin' | string;
export const getRoleByNumber: GetRoleByNumberFuncType = (role, t) => {
  switch (role) {
    case 1:
      return t ? t('admin.users.filters.user') : 'user';
    case 2:
      return 'admin';
    case 3:
      return 'firmadmin';
    case 4:
      return 'superadmin';
    default:
      return t ? t('admin.users.filters.user') : 'user';
  }
};

export const setFavicon = (favicon: string) => {
  const links = document.querySelectorAll<HTMLLinkElement>("link[rel*='icon']");
  links.forEach(link => {
    link.href = favicon;
  });
};

// Logged-out visitors (the enroll page) never load the heavy login code.
export const login = async () => {
  if (!isLoggedIn()) return;

  const misc = await import('./misc');

  return misc.login();
};
